import { EditGoal, SequenceGoal } from '../SequenceGoal/SequenceGoal.types';

export interface EditContentProps {
  data: EditGoal;
  onSubmit: (data: SequenceGoal[]) => void;
}

export const formatDate: string = 'MM/dd/yyyy';
